import moment from "moment";
import { getUserInfo, stringMaker, toTitleCase } from "../../oro-module/commonFunctions";



function getTextWidths({ col, basicParams }) {
  let width80, width132 = {};
  for (var key in basicParams.page80) {
    if (!col.width80) {
      col.width80 = { [key]: basicParams.page80[key] };
    }
    else if (!col.width80[key]) {
      col.width80[key] = basicParams.page80[key];
    }
  }
  for (var key in basicParams.page132) {
    if (!col.width132) {
      col.width132 = { [key]: basicParams.page132[key] };
    }
    else if (!col.width132[key]) {
      col.width132[key] = basicParams.page132[key];
    }
  }
  return col;
}

function getAccessors({ displayColumns, type = 'currency', converting = {}, basicParams = {} }) {

  for (var key in displayColumns) {
    let c = displayColumns[key];
    if (c.accessor) {
      let defi = getTextWidths({ col: c, basicParams });
      defi['res'] = true;
      // if (c.width80) {
      //   defi.width80 = c.width80;
      // }
      // if (c.width132) {
      //   defi.width132 = c.width132;
      // }

      if (type == 'currency') {
        if (c.type == 'currency') { converting[c.accessor] = defi; }
      } else {
        if (c.formula) {
          defi.valtype = 'f';
          defi.res = c.formula;
        }
        converting[c.accessor] = defi;
      }
    } else if (c.columns) {
      converting = getAccessors({ displayColumns: c.columns, basicParams, type, converting });
    }
  }
  return converting;
}




function getHeaderRowsForTextReport({ statutoryColumns, basicParams, header1 = [] }) {
  // [ [{Sr,}] ,[]]
  let w80 = statutoryColumns.length - 1; let w132 = statutoryColumns.length - 1;

  let h2 = [];
  for (var key in statutoryColumns) {
    let col = statutoryColumns[key];
    if (col.columns) {
      let { w80, w132, header2 } = getHeaderRowsForTextReport({ statutoryColumns: col.columns, basicParams, header1 });
      let { width80, width132 } = getTextWidths({ col: { Header: col.Header, width80: { size: w80 }, width132: { size: w132 } }, basicParams });
      header1.push({ Header: col.Header, skip_rows: "skip_rows", width80, width132 });
      if (header2.length > 0) {
        h2 = h2.concat(header2);
      }
    } else {
      let { width80, width132 } = getTextWidths({ col, basicParams });
      let tmp = { ...col };
      tmp['width80'] = width80;
      tmp['width132'] = width132;
      tmp['skip_rows'] = "skip_rows";
      h2.push(tmp);

      w80 += width80.size ? parseInt(width80.size) : 0;
      w132 += width132.size ? parseInt(width132.size) : 0;
    }
  }
  return { header1, header2: h2, w80, w132 };
}

function createTextReportField({ def, val = '', col }) {
  let fieldVal = []; let leftpad = 0; let rightpad = 0;
  let padder = ' ';
  let lines = 1;

  if (def) {
    let fieldWidth = def.size;

    let { headeralign, fieldalign, align } = def;
    // Check for align
    if (!def.comma) {
      val = String(val).replace(/,/g, '');
    }

    if (val.length > fieldWidth && def.wraplines) {
      lines = def.wraplines;
    }
    if (!align) {
      if (col && col.type == 'currency') {
        align = 'right';
      }
      else if (col.align) {
        align = col.align;
      }
      else {
        align = 'left';
      }
    }
    // console.log({col})
    // if(col.accessor=='amount'){
    //   console.log({align});
    // }

    for (var i = 0; i < lines; i++) {
      let shortval = String(val).substr(i * fieldWidth, fieldWidth);
      padder = def.padder ? def.padder : " ";
      if (align) {
        if (align == 'center') {
          leftpad = Math.round((fieldWidth - shortval.length) / 2);
          rightpad = fieldWidth - shortval.length - leftpad;
        } else if (align == 'left') {
          rightpad = fieldWidth - shortval.length;
        } else {
          leftpad = fieldWidth - shortval.length;
        }
      } else if (def.padding) {
        if (def.padding.type == 'left') {
          leftpad = def.padding.size;
          rightpad = fieldWidth - shortval.length - leftpad;
        } else {
          rightpad = def.padding.size;
          leftpad = fieldWidth - shortval.length - rightpad;
        }
      }
      fieldVal.push(padder.repeat(leftpad) + shortval + padder.repeat(rightpad));
    }
  } else {
    fieldVal = [val];
  }

  return fieldVal;
}

function createTextReportRow({ row, basicParams, textPageSize }) {
  let textRow = [];
  let fields = [];
  let rowHeight = 1;
  let separator = "";
  let skip_columns = basicParams['page' + textPageSize].skip_columns;

  if (basicParams['page' + textPageSize] && basicParams['page' + textPageSize].separator) {
    separator = basicParams['page' + textPageSize].separator;
  }
  // console.log({ row, textPageSize });
  row.map(col => {
    let cv = (col.val || col.val == 0) ? String(col.val) : col.Header ? col.Header : '';
    let colval = createTextReportField({ def: col['width' + textPageSize], val: cv, col });
    rowHeight = Math.max(rowHeight, colval.length);
    if (col.accessor.indexOf(skip_columns) == -1) {
      fields.push(colval);
    }
  });

  for (var i = 0; i < rowHeight; i++) {
    let row1 = [];
    fields.map(f => {
      if (f[i]) {
        row1.push(f[i]);
      } else {
        row1.push(' '.repeat(f[0].length));
      }
    });
    textRow.push(row1.join(separator));
  }
  return textRow.join("\n");
}



function getPageHeaderFieldsForTextReport({ row, history, pageData, textPageSize }) {
  let record = [];
  row.map(col => {
    let fld = {};
    if (!col.source || col.source == 'pageData') {
      fld['val'] = pageData[col.field];
    }
    else if (col.source == 'history') {
      fld['val'] = history[col.field];
    } else if (col.source == 'fixed') {
      fld['val'] = col.value;
    }
    if (!fld['val']) { fld['val'] = ''; }
    fld['width' + textPageSize] = { size: fld['val'].length + 1, fieldalign: 'left' };

    if (col.type) {
      if (col.type == 'date') {
        fld['val'] = fld['val'] ? moment(fld['val']).format('DD/MM/YYYY') : "";
      }
    }

    if (col.conversion) {
      if (col.conversion.type == 'date') {

      }
    }


    if (col.style) {
      fld['width' + textPageSize] = {};
      for (var key in col.style) {
        fld['width' + textPageSize][key] = col.style[key];
      }
    }
    record.push(fld);
  });
  return record;
}

function getPageHeaderRowsForTextReport({ rows, history, pageData, textPageSize }) {
  let allData = [];
  for (var i = 0; i < rows.length; i++) {
    let row = rows[i];
    let record = getPageHeaderFieldsForTextReport({ row, history, pageData, textPageSize });
    allData.push(record);
  }
  return allData;
}

function getPageHeaderForTextReport({ pageData, history, basicParams, textPageSize }) {
  // If no definitions are given, show branch name, date, currency (if not units)
  let bankName = "The Haryana State Co-Operative Apex Bank Ltd.";
  let pageIdDef = [[{ source: 'history', field: 'reportHeader' }, { source: 'fixed', value: 'As on Date' }, { field: 'as_on_date', type: 'date' }],
  [{ source: 'fixed', value: 'Parent Branch' }, { field: 'branch_code' }, { source: 'fixed', value: '-' }, { field: 'branch_display' }]];

  let { textReportProps } = history;
  let header;
  let tps = textReportProps[textPageSize];
  header = tps.header;
  if (tps && tps.header != 'default') {
    pageIdDef = tps.header;
  }
  let pageHeaderRows = [];

  if (header) {
    pageHeaderRows = [[{ val: bankName, width80: { size: 80, fieldalign: 'left' }, width132: { size: 132, fieldalign: 'left' } }]];
    let otherRows = getPageHeaderRowsForTextReport({ rows: pageIdDef, history, pageData, textPageSize });
    pageHeaderRows = pageHeaderRows.concat(otherRows);

    let headText = '';
    for (var key in pageHeaderRows) {
      let row = pageHeaderRows[key];
      headText += createTextReportRow({ row, textPageSize, basicParams }) + "\n";
    }
  }
  return pageHeaderRows;
}


function convertTableRecordToTextRecord({ header, accessors, record }) {
  let rec = [];
  for (var k in header) {
    let col = header[k];
    let tmp = { ...accessors[col.accessor] };

    tmp['val'] = record[col.accessor];
    tmp['skip_rows'] = record._original ? record._original.skip_rows : record.skip_rows;
    delete tmp.Header;
    rec.push(tmp);
  }
  return rec;
}

function getFloat(num) {
  return !isNaN(parseFloat(num)) ? parseFloat(Number(num).toFixed(2)) : 0;
}


const grandTotal = (grandtotalRule, tableData, fields) => {
  let tot = {};
  tableData.map(row => {
    fields.map(f => {
      let stot = getFloat(row[f]);
      if (tot[f]) {
        tot[f] = getFloat(tot[f] + stot);
      } else {
        tot[f] = stot;
      }
    })
  });
  tot.skip_rows = 'grand_total';
  tot.main_col = grandtotalRule.displayIn;
  tot[grandtotalRule.displayIn] = grandtotalRule.val;
  return tot;
}


const createGroupingStatistics = ({ subtotalRule, tableData, fields, level, parent }) => {
  let { by, displayIn, labels, groupsOnly, count, otherstat, location, subtotals } = subtotalRule;
  let grouped = {}; // 1:{rows:[],substats:{}, subtots:{}}, 2:{rows:[],substats, subtots:{}}
  let final = [];
  tableData.map((row, idx) => {
    if (grouped[row[by]]) {
      fields.map(f => {
        let tot = getFloat(row[f]);
        grouped[row[by]]['subtots'][f] = getFloat(grouped[row[by]]['subtots'][f] + tot);
        grouped[row[by]]['substats'][f].push(tot);
      });
      row['row_id'] = grouped[row[by]]['rows'].length;
      grouped[row[by]]['rows'].push(row);
    } else {
      let subtots = {}; let substats = {};
      fields.map(f => {
        let tot = getFloat(row[f]);
        subtots[f] = tot;
        substats[f] = [tot];
      });
      row['row_id'] = 0;
      grouped[row[by]] = { rows: [row], subtots, substats };
    }
  })

  // if (!labels) {
  // When subtotal labels are to be taken from the data itself.
  // Currently it can neither take labels from any other field, nor do nested subtotals in such case.
  Object.keys(grouped).map((grby, idx) => {
    let curpar = idx;
    if (parent || parent == '0') {
      curpar = parent + "_" + idx;
    }

    let st = grouped[grby].subtots;
    st[displayIn] = labels ? labels[grby] : grby;
    st['main_col'] = displayIn;
    let myID = "grp_" + curpar;
    st['row_id'] = myID;
    st['level'] = level;
    st['skip_rows'] = "grouped_row";

    st['prev_row_index'] = parent;
    let subFinal = [];

    if (subtotals) {
      subFinal = createGroupingStatistics({ subtotalRule: subtotals, tableData: grouped[grby].rows, fields, level: level + 1, parent: curpar });
    } else {
      subFinal = grouped[grby].rows;
    }
    st['subRows'] = subFinal;
    if (count) {
      st[displayIn] = st[displayIn] + " (" + subFinal.length + ")"
    }
    final.push(st);
  });
  if (final.length > 0) {
    for (let index in final) {
      let data = final[index]
      if (data["Details"] == "Other Details") {
        console.log("ENTERED")
        data["discriptions"] = " "
      }

    }
  }
  // }
  return final;
}


const generateNewRowsToTable = ({ tableData, extraRows }) => {
  // 
  let subtot = [];
  let grandtot = [];
  if (extraRows.subtotals) {
    subtot = createGroupingStatistics({ subtotalRule: extraRows.subtotals, tableData, fields: extraRows.fields, level: 1 });
  }
  else {
    subtot = tableData;
  }
  if (extraRows.grandtotal && tableData.length > 0) {
    grandtot = grandTotal(extraRows.grandtotal, tableData, extraRows.fields);
  }
  let groupedData = subtot.concat(grandtot);

  return groupedData;
}

function getTableBodyForTextReport({ current, pageData, history, statutoryColumns, reportData, accessors, textPageSize, basicParams, headers }) {
  let { textReportProps } = history;
  let { profile } = current.props.parentProps.parentState;
  let { display_name, assigned_branch, session_date, roles, username } = profile;
  display_name = toTitleCase(display_name);
  roles = (roles.map(r => r.role).join(", ")).toUpperCase();

  let tps = textReportProps[textPageSize];
  let x;

  // Create report identifier such as bank name. 
  let pageHeader = [];
  if (tps) {
    pageHeader = getPageHeaderForTextReport({ pageData, history, basicParams, textPageSize, headers });
  }
  // Create table header
  // let tableHeader = getTableHeaderForTextReport({ statutoryColumns, basicParams, textPageSize, headers });
  let tableHeader = headers;
  let header = headers[1];
  let bodyText = '';
  let records = [];

  let footerHeight = 0;
  if (textReportProps && textReportProps.footer) {
    footerHeight = textReportProps.footer['width' + textPageSize].length;
  }
  let maxReportRowsPerPage = 10000000;
  if (basicParams['page' + textPageSize] && basicParams['page' + textPageSize].autofooter) {
    maxReportRowsPerPage = basicParams['page' + textPageSize].height - pageHeader.length - tableHeader.length - footerHeight;
  }

  let sectionData = [];
  for (var i = 0; i < reportData.length; i++) {
    let record = reportData[i];
    if (sectionData.length == 0) {
      if (basicParams['page' + textPageSize] && basicParams['page' + textPageSize].autofooter) {
        if (pageHeader.length > 0) {
          records = records.concat(pageHeader);
        }
        if (headers.length > 0) {
          headers.map(head => head.length > 0 ? records.push(head) : x = 0)
        }
      }
    }

    let rec = convertTableRecordToTextRecord({ header, accessors, record });
    records.push(rec);
    sectionData.push(record);

    if (i >= maxReportRowsPerPage && i % maxReportRowsPerPage == 0) {
      records.push([{ val: `Date: ${moment().format('DD/MM/YYYY')}    Time:${moment().format('HH:mm:ss')}   Print By: ${display_name}`, width80: { size: 80, fieldalign: 'left' }, width132: { size: 80, fieldalign: 'left' } }]);
      records.push([{ val: "\f", width80: { size: 80, fieldalign: 'left' }, width132: { size: 80, fieldalign: 'left' } }]);
      sectionData = [];
    }
  }
  if (basicParams['page' + textPageSize] && basicParams['page' + textPageSize].autofooter) {
    // Add report footer.
    if (sectionData.length > 0) {
      records.push([{ val: `Date: ${moment().format('DD/MM/YYYY')}    Time:${moment().format('HH:mm:ss')}   Print By: ${display_name}`, width80: { size: 80, fieldalign: 'left' }, width132: { size: 80, fieldalign: 'left' } }]);
      records.push([{ val: "\f", width80: { size: 80, fieldalign: 'left' }, width132: { size: 80, fieldalign: 'left' } }]);
    }
  }

  let lastbold = false;
  for (var i = 0; i < records.length; i++) {
    let record = records[i];

    if (record[0].skip_rows && !lastbold) {
      bodyText += '-'.repeat(parseInt(textPageSize)) + "\n";
    }
    bodyText += createTextReportRow({ row: record, textPageSize, basicParams }) + "\n";
    if (record[0].skip_rows) {
      bodyText += '-'.repeat(parseInt(textPageSize)) + "\n";
      lastbold = true;
    } else {
      lastbold = false;
    }
  }
  return bodyText;
}

const createTextReport = ({ statutoryColumns, reportData, displayColumnsStyled, accessors, textPageSize, basicParams, current }) => {
  // if currency pad left by default.

  let textReport = '';
  let final = {};
  let { header1, header2 } = getHeaderRowsForTextReport({ statutoryColumns, basicParams });
  let { formElements, currentPage, pageData } = current.props.parentState;
  let { history } = formElements[currentPage];

  // Create table body
  textReport += getTableBodyForTextReport({ current, pageData, history, reportData, accessors, textPageSize, basicParams, statutoryColumns, headers: [header1, header2] });

  return textReport;
}

function createReportHeader(reportHeader, pageData) {
  for (var key in pageData) {
    reportHeader = reportHeader.replace("$" + key + "$", pageData[key]);
  }
  return reportHeader;
}

function createAndDownloadFile({ dfilename, textReport, pageData }) {
  var element = document.createElement('a');
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(textReport));
  // let filename = dfilename;
  // let formvar = dfilename.match(/\$([^)]+)\$/);
  // if (formvar) {
  //   console.log({ formvar: formvar[1] });
  //   filename = dfilename.replace(/\$([^)]+)\$/, pageData[formvar[1]]);
  // }
  element.setAttribute('download', dfilename);
  element.style.display = 'none';
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
}

function downloadTextReport({ reportData, statutoryColumns, current, sentData, basicParams }) {

  let accessors = getAccessors({ displayColumns: statutoryColumns, type: 'all', basicParams });

  let { currentPage, pageData, formElements, localpage, textPageSize } = current.props.parentState;

  let textReport = createTextReport({ statutoryColumns, reportData, displayColumnsStyled: statutoryColumns, current, accessors, textPageSize, basicParams });

  if (localpage) {
    currentPage = localpage;
  }
  let { history } = formElements[currentPage];
  let { reportHeader, textReportProps } = history;
  reportHeader = createReportHeader(reportHeader, pageData);

  let dfilename = reportHeader + ".rpt";
  if (textReportProps[textPageSize] && textReportProps[textPageSize].filename) {
    dfilename = textReportProps[textPageSize].filename;
    if (dfilename.indexOf('$') != -1) {
      dfilename = stringMaker({ orig: dfilename, data: current.props.parentState });
    }
  } else if (textReportProps[textPageSize] && textReportProps[textPageSize].filetype) {
    if (textReportProps[textPageSize].filetype == 'apb') {
      let parts = pageData['apb_file_display'].split("-");
      dfilename = parts[0] + "-" + parts[1] + "-" + parts[2] + "-" + "PARXH2HUSER1" + "-" + parts[3] + "-" + parts[4].replace("TPZD", "") + "-RTN.txt"
    }
  }
  // console.log({dfilename});
  createAndDownloadFile({ dfilename, textReport, pageData });
}

export {
  downloadTextReport,
  generateNewRowsToTable,
  getAccessors
}